<template>
  <div
    :class="{ 'with-top-border': withTopBorder }"
    class="scaled-bar d-flex flex-column"
  >
    <div v-if="withLines" class="lines d-flex flex-row">
      <div :style="{ width: lowSegmentWidth + '%' }" class="line line-1"></div>
      <div
        :style="{ width: averageSegmentWidth + '%' }"
        class="line line-2"
      ></div>
      <div :style="{ width: highSegmentWidth + '%' }" class="line line-3"></div>
    </div>
    <div class="ticks d-flex flex-row align-items-start">
      <div
        v-for="tick in [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        ]"
        :key="tick"
        class="tick"
      >
        <div v-if="tick === 1" class="value i-text-body-3">0</div>
        <div v-if="tick === 6" class="value i-text-body-3">25</div>
        <div v-if="tick === 11" class="value i-text-body-3">50</div>
        <div v-if="tick === 16" class="value i-text-body-3">75</div>
        <div v-if="tick === 20" class="value i-text-body-3">100</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as trustScoreThresholds from '@/constants/trustScoreThresholds';
export default {
  components: {},
  props: {
    withLines: {
      type: Boolean,
      default: false,
    },
    withTopBorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    lowSegmentWidth() {
      return trustScoreThresholds.LOW;
    },
    averageSegmentWidth() {
      return trustScoreThresholds.HIGH - trustScoreThresholds.LOW;
    },
    highSegmentWidth() {
      return 100 - trustScoreThresholds.HIGH;
    },
  },
};
</script>

<style lang="scss" scoped>
.scaled-bar {
  width: 100%;
  height: 28px;
  gap: 4px;

  &.with-top-border {
    border-top: 1px solid $light-neutral-30;
  }
  .lines {
    width: 100%;
    height: 4px;

    .line {
      height: 4px;
      border-radius: 24px;

      &.line-1 {
        background: $light-error-40;
      }

      &.line-2 {
        margin-left: 3px;
        margin-right: 3px;
        background: $light-neutral-30;
      }

      &.line-3 {
        background: $light-success-40;
      }
    }
  }
  .ticks {
    position: relative;
    width: 100%;
    height: 10px;
    .tick {
      position: relative;
      border-left: 1px solid $light-neutral-60;
      width: 5%;
      height: 5px;
      color: $light-neutral-100;

      .value {
        color: $light-neutral-100;
        position: absolute;
        left: -50%;
        top: 12px;
      }

      &:first-of-type {
        .value {
          left: 0;
        }
      }

      &:last-of-type {
        .value {
          left: 0;
        }
      }

      &:nth-of-type(1),
      &:nth-of-type(6),
      &:nth-of-type(11),
      &:nth-of-type(16) {
        height: 10px;
      }
      &:nth-of-type(19) {
        border-right: 1px solid $light-neutral-60;
      }
      &:nth-of-type(20) {
        height: 10px;
        border-left: 0;
        border-right: 1px solid $light-neutral-60;
      }
    }
  }
}
</style>
